<template>
  <div>
    <b-modal v-model="showModal"
      title="Datos del registro"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="md">
      <div><span><b>Evento:</b> {{ record.event }}</span></div>
      <div><span><b>User:</b> {{ record.useremail }}</span></div>
      <div v-if="record.coursename"><span><b>Curso:</b> {{ record.coursename }}</span></div>
      <div v-if="record.modulename"><span><b>Módulo:</b> {{ record.modulename }}</span></div>
      <div v-if="record.information.ip"><span><b>Ip:</b> {{ record.information.ip }}</span></div>
      <div v-if="record.information.browser"><span><b>Navegador:</b> {{ record.information.browser }}</span></div>
      <div v-if="record.information.os"><span><b>Sistema Operativo:</b> {{ record.information.os }}</span></div>
      <div v-if="record.information.description"><span><b>Descripción:</b> {{ record.information.description }}</span></div>
      <hr>
      <div v-if="record.video">
        <span><b>Video:</b></span>
      </div>
      <div v-if="record.video" class="container">
        <div class="row p-2 m-1" style="background-color: #efefef; border-radius: 10px;">
          <div class="col-12 text-center">
            <video-intro :courseid="record.id"></video-intro>
          </div>
        </div>
      </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-danger" type="button" @click="close"> <i class="fas fa-times fa-fw"></i>Cerrar</button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import VideoIntro from '../../MyCourse/partials/VideoIntro.vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal } from 'bootstrap-vue';

export default {
  components: {BModal, VideoIntro},
  props: ['record', 'showModal'],
  data() {
    return {
      form: {},
      loading: false,
      dataRecord: [],
    }
  },
  methods:{
    close(bvModalEvent) {
      this.$emit('update:showModal', false)
      // this.$emit('getRecords');
      // bvModalEvent.preventDefault()
    },
    getRecord() {
      this.loading = true
      this.form = {
        id: this.id
      }
    },
  }
}

</script>